import PropTypes from 'prop-types';
// @mui
import { Box, Container, useTheme } from '@mui/material';

// ----------------------------------------------------------------------

interface Props {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	size?: string;
}

export const CenteredContent = (props: Props) => {
	return (
		<Box
			sx={{
				height: '100%',
				display: 'flex',
				flex: 1,
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			{props.children}
		</Box>
	);
};

export const CenteredText = (props: Props) => {
	return (
		<Box
			sx={{
				textAlign: 'center',
			}}
		>
			{props.children}
		</Box>
	);
};

export const CenteredNarrowContent = (props: Props) => {
	const theme = useTheme();
	return (
		<Box maxWidth="100%">
			<Container maxWidth="sm" sx={{ [theme.breakpoints.down('sm')]: { padding: 0 } }}>
				{props.children}
			</Container>
		</Box>
	);
};

export const PositionMiddleScreen = (props: Props) => {
	return (
		<Box
			sx={{
				marginTop: `calc(50vh - ${props.size || 0})`,
			}}
		>
			{props.children}
		</Box>
	);
};
